export function examUpdate(){
  // Empty file created to manage rendered files in common
}